"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DateInput = require("./DateInput");
Object.keys(_DateInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DateInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DateInput[key];
    }
  });
});